import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Form, Stack, Button } from 'react-bootstrap';

//import ssImg from '../images/ss-small.jpg';
import ssImg from '../images/seniorspray_round.png';

const product_price = 44.00;
const shipping_price = 25.00;
//var total = 0.00;


export default function ConfirmForm() {

	const [cartTotal, setCartTotal] = useState(product_price);
	const [qtyTotal, setQtyTotal] = useState(1);
	const [shippingChecked, setShippingChecked] = useState(false);
	//const [shippingCost, setshippingCost] = useState();

	const options = [1,2,3,4,5,6,7,8,9];

	//setCartTotal = (product_price + shippingPrice);

	useEffect(() => {
        var total;
      
        //console.log(`qty: ${qtyTotal} -> shipping: ${shippingChecked} -> cartTotal: ${cartTotal}`);

        if (shippingChecked === true) {
            //console.log("running an update with shipping checked");
            total = (qtyTotal * product_price) + shipping_price;

        } else {
            //console.log("running an update without shipping");
            total = qtyTotal * product_price;

        }

        var newTotal = parseFloat(total).toFixed(2);
        //console.log(`ran started: ${newTotal}`);

        setCartTotal(newTotal);

	}, [qtyTotal, shippingChecked, cartTotal]);

	const updateQty = (event) => {
    	//console.log(`running an update total ${cartTotal} curval: ${event.target.value} qty: ${qtyTotal}`);
		setQtyTotal(event.target.value);

		//console.log("new value:" + qtyTotal);

		//updateTotal();

  	};

  	const shippingUpdate = (event) => {
		setShippingChecked(event.target.checked);
		//console.log(shippingChecked);

		//updateTotal();
    	//setCartTotal(total);

    };

	/*

    const updateTotal = () => {

		var total;

		//console.log(`qty: ${qtyTotal} -> shipping: ${shippingChecked} -> cartTotal: ${cartTotal}`);

        if (shippingChecked === false) {
            //console.log("running an update with shipping checked");
            total = (qtyTotal * product_price) + shipping_price;

        } else {
            //console.log("running an update without shipping");
           	total = qtyTotal * product_price;

        }

        var newTotal = parseFloat(total).toFixed(2);
        //console.log(newTotal);

        setCartTotal(newTotal);


    }

	*/

		const nav = useNavigate();
		const cartData = {qty: qtyTotal, shipping: shippingChecked};

		const handleClick = () => {
			nav('/checkout', {state: cartData});
		};




    //const handleClick = () => setShippingChecked(!shippingChecked);
	//



	return (
		<>
		<br />
		<br />
		<br />
		<Stack gap={3} >
	 	<img src={ssImg} className='rounded col-md-3 mx-auto' style={{width: '25%'}} alt='senior spray bottle' />
    <div className="col-md-5 mx-auto">
	<Form.Label>Select Quantity</Form.Label>
	 <Form.Select value={qtyTotal} onChange={updateQty}>
	  {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
      ))}
      </Form.Select>
		  </div>
	<br />
		<div className='col-md-5 mx-auto'>
		<Form.Check type='checkbox' checked={shippingChecked} id='shipping-checkbox' label='Shipping' onChange={shippingUpdate} />
		</div>
	    <div className='col-md-5 mx-auto text-end'>
		 <label>Total:&nbsp;</label>
		 <label name='total'><b>${cartTotal}</b></label>
	  </div>
	  <br />
	  </Stack>
	  <Stack gap={2} className="col-md-5 mx-auto">
		<Button variant="secondary" onClick={handleClick}>Next</Button>
      </Stack>
	  </>

	  );
}
